import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './ui/icon.component';
import { AnimateDirective } from '../directives/animate.directive';

@Component({
  selector: 'app-risk-v2',
  standalone: true,
  imports: [CommonModule, IconComponent, AnimateDirective],
  template: `
    <section id="risk" class="flex flex-col justify-center pt-8 md:pt-12 pb-5 bg-[#111111] relative overflow-hidden">
      <!-- Subtle pattern -->
      <div class="absolute inset-0 hexagon-bg opacity-30"></div>
      <!-- Tech Background Overlay -->
      <div class="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gray-800/20 via-[#111111] to-[#111111] pointer-events-none"></div>

      <div class="container mx-auto px-4 md:px-6 relative z-10">
        <div class="max-w-5xl mx-auto text-center mb-12">
          <h2 appAnimate class="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Cada dia sem controle de pausa térmica é um risco que você está assumindo sozinho.
          </h2>
          <p appAnimate [delay]="100" class="text-gray-300 text-lg md:text-xl font-light">
            A fiscalização do Ministério do Trabalho está cada vez mais rigorosa. E a lei não perdoa quem não tem documentação.
          </p>
        </div>

        <div class="grid md:grid-cols-3 gap-8">
          <!-- Card 1 -->
          <div appAnimate [delay]="200" class="h-full">
            <div class="bg-[#1c1c1c] border border-white/5 rounded-2xl p-8 hover:border-[#FF5500]/50 transition-all duration-300 group flex flex-col hover:shadow-2xl hover:shadow-[#FF5500]/5 h-full">
              <div class="w-14 h-14 rounded-xl bg-[#111111] border border-white/10 flex items-center justify-center text-[#FF5500] mb-6 group-hover:scale-110 transition-transform shadow-lg group-hover:bg-[#FF5500]/10 group-hover:border-[#FF5500]/20">
                <app-icon name="clock" [size]="32"></app-icon>
              </div>
              <h3 class="text-xl font-bold text-[#FF5500] mb-3">A lei é inflexível</h3>
              <p class="text-white leading-relaxed text-base">
                A NR 36 determina que a cada 1h40 em ambiente abaixo de 15°C, o colaborador tem direito a 20 minutos de pausa em ambiente aquecido. Sem registro comprovado, você já está em infração.
              </p>
            </div>
          </div>

          <!-- Card 2 -->
          <div appAnimate [delay]="400" class="h-full">
            <div class="bg-[#1c1c1c] border border-white/5 rounded-2xl p-8 hover:border-red-500/50 transition-all duration-300 group flex flex-col hover:shadow-2xl hover:shadow-red-500/5 h-full">
              <div class="w-14 h-14 rounded-xl bg-[#111111] border border-white/10 flex items-center justify-center text-red-500 mb-6 group-hover:scale-110 transition-transform shadow-lg group-hover:bg-red-500/10 group-hover:border-red-500/20">
                <app-icon name="shield-alert" [size]="32"></app-icon>
              </div>
              <h3 class="text-xl font-bold text-[#FF5500] mb-3">O custo é mais alto do que parece</h3>
              <p class="text-white leading-relaxed text-base">
                Uma única ação trabalhista por descumprimento da NR 36 pode gerar multas, indenizações e honorários que ultrapassam facilmente R$ 80.000. Sem contar o desgaste e o tempo do seu time jurídico.
              </p>
            </div>
          </div>

          <!-- Card 3 -->
          <div appAnimate [delay]="600" class="h-full">
            <div class="bg-[#1c1c1c] border border-white/5 rounded-2xl p-8 hover:border-green-500/50 transition-all duration-300 group flex flex-col hover:shadow-2xl hover:shadow-green-500/5 h-full">
              <div class="w-14 h-14 rounded-xl bg-[#111111] border border-white/10 flex items-center justify-center text-green-500 mb-6 group-hover:scale-110 transition-transform shadow-lg group-hover:bg-green-500/10 group-hover:border-green-500/20">
                <app-icon name="check-circle" [size]="32"></app-icon>
              </div>
              <h3 class="text-xl font-bold text-[#FF5500] mb-3">Planilha não é prova jurídica</h3>
              <p class="text-white leading-relaxed text-base">
                Controles manuais, relógios ponto e anotações em papel são facilmente contestados na Justiça do Trabalho. Só um sistema automatizado e auditável garante sua defesa.
              </p>
            </div>
          </div>
        </div>

        <!-- CTA below cards -->
        <div appAnimate [delay]="700" class="flex flex-col items-center gap-2 mt-12">
          <button (click)="scrollToCta()" class="bg-[#FF5500] hover:bg-[#E04800] text-[#111111] px-8 py-4 rounded-lg font-bold transition-all shadow-lg shadow-[#FF5500]/20 hover:shadow-[#FF5500]/40 flex flex-col items-center">
            <span class="text-lg font-extrabold leading-tight tracking-wide">SIMULE AGORA</span>
            <span class="text-sm font-normal leading-tight">o controle da pausa térmica da sua empresa</span>
          </button>
          <span class="text-sm text-gray-400">Diagnóstico gratuito em até 24h</span>
        </div>
      </div>
    </section>
  `
})
export class RiskV2Component {
  scrollToCta() {
    const el = document.getElementById('simulador');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
